import { SERVICES, SUBURBS } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="bg-pearl py-32 md:py-44"
        >
            <div className="max-w-[1300px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-20 md:mb-28">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <p className="eyebrow text-cacao/60 mb-8">
                                <span className="divider-line text-cacao/40 mr-4 align-middle" />
                                How we help
                            </p>
                        </Reveal>
                        <Reveal delay={120}>
                            <h2
                                data-testid="services-headline"
                                className="font-serif text-cacao text-[2.4rem] sm:text-[3.2rem] md:text-[4rem] leading-[1.02]"
                            >
                                {"From first idea"}
                                <br />
                                {"to "}<em className="italic text-clay-deep">{"finished room."}</em>
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7 lg:pl-10 flex items-end">
                        <Reveal delay={240}>
                            <p className="text-cacao/75 text-[1.02rem] leading-[1.85] font-light max-w-[34rem]">
                                {"Whether you\u2019re refreshing a single room or reimagining a whole home, we guide every stage with care, clarity and attention to detail."}
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-cacao/10 border border-cacao/10"
                    data-testid="services-grid"
                >
                    {SERVICES.map((s, i) => (
                        <Reveal
                            key={s.title}
                            delay={i * 80}
                            className="group bg-pearl p-8 md:p-12 min-h-[260px] flex flex-col justify-between transition-colors duration-700 hover:bg-pearl-soft"
                        >
                            <span className="font-serif text-clay text-[0.95rem] tracking-[0.14em]">
                                0{i + 1}
                            </span>
                            <div className="mt-12">
                                <h3
                                    className="font-serif text-cacao text-[1.55rem] md:text-[1.8rem] leading-[1.15] mb-4 transition-colors duration-700 group-hover:text-clay-deep"
                                    data-testid={`service-title-${i}`}
                                >
                                    {s.title}
                                </h3>
                                <p className="text-cacao/75 text-[0.95rem] leading-[1.7] font-light">
                                    {s.body}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={300}>
                    <p
                        data-testid="services-suburbs"
                        className="mt-16 text-cacao/60 text-[0.78rem] tracking-[0.22em] uppercase italic font-serif text-center"
                    >
                        {`Servicing Brisbane\u2019s inner east & riverside — ${SUBURBS}`}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
